import { Arrow } from '@dynamika-shared/ui/icons';
import React from 'react';
import { twJoin } from '@utils/twMerge';

interface NextButtonProps {
  onClick?: () => void;
  disabled?: boolean;
}

export const NextButton: React.FC<NextButtonProps> = ({
  onClick,
  disabled = false,
}) => {

  return (
    <div
      className=' upload-button-wrapper relative ml-3'
      data-testid='UploadNextButton'
      onClick={onClick}
      aria-disabled={disabled}
    >
      <Arrow
        className={twJoin(
          'relative z-50 h-7 w-7 cursor-pointer rounded-full border border-vividTangelo bg-seashell p-1.5 text-vividTangelo hover:border-honoluluBlue hover:bg-dodgerBlue hover:text-white',
          disabled && '!text-pastelBlue border-none !bg-pageBackgroundWhite'
        )}
      />
      <div className='confirmation-message'>
        <p className='animated-text text-1016 text-black'>Confirm</p>
      </div>
    </div>
  );
};
